export default __webpack_public_path__ + "static/media/tags.cae096f9.png";